var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generatechart",attrs:{"data-aos":"slide-down","data-aos-delay":"0"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex"}},[_c('iframe',{staticStyle:{"width":"100%","flex":"1"},attrs:{"src":"https://osscold.baozhida.cn/Tool/DataTool.html","allowfullscreen":"allowfullscreen","frameborder":"0","data-id":"1"}})])])
}]

export { render, staticRenderFns }